module.exports = __webpack_public_path__ + "static/img/xl_btn1.213fc01.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/home/pc/role3/control/xl_btn1.png
// module id = 6W84
// module chunks = 7